export default __webpack_public_path__ + "static/07.05-b572b1e07ada4d4e84c6dd2243674307.png";